"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveGatesUpdate = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
// [userId, Gates]
exports.receiveGatesUpdate = (0, typesafe_actions_1.createStandardAction)(constants_1.RECEIVE_GATES_UPDATE)();